import React from "react";
import "./Packaging.css"; // Assuming you have a CSS file for styling

const Packaging = () => {
  return (
    <div>
        <section className="common-page-hero">
        <img
          src="assets/img/service/mw7.png"
          className="common-hero-bg ak-bg"
          alt="..."
        />
        <div className="common-hero-content">
          <div className="common-hero-info">
            <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
              <p
                className="ak-section-subtitle animation-title"
                style={{ perspective: "400px" }}
              >
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"Courses".split("").map((char, index) => (
                    <div
                      key={index}
                      style={{
                        position: "relative",
                        display: "inline-block",
                        transform: "translate(0px, 0px)",
                        opacity: 1,
                      }}
                    >
                      {char}
                    </div>
                  ))}
                </div>
              </p>
              <br />
              <p
                className="mini-title1"
                style={{
                  backgroundColor: "rgb(232, 119, 34)",
                  color: "white",
                  padding: "5px 10px",
                  fontWeight: "bold",
                  display: "inline-block",
                  borderRadius: "5px",
                }}
              >
                SEMANTIC Skills Junction
              </p>
              <br />
              <h2
                className="ak-section-title animation-title"
                style={{ fontSize: "45px", perspective: "400px" }}
              >
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"SEMANTIC Skills Junction: Bridging"
                    .split(" ")
                    .map((word, idx1) => (
                      <span
                        key={idx1}
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        {word.split("").map((char, idx2) => (
                          <div
                            key={idx2}
                            style={{
                              position: "relative",
                              display: "inline-block",
                              transform: "translate(0px, 0px)",
                              opacity: 1,
                            }}
                          >
                            {char}
                          </div>
                        ))}
                        &nbsp;
                      </span>
                    ))}
                </div>
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"Talent and Technology".split(" ").map((word, idx1) => (
                    <span
                      key={idx1}
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      {word.split("").map((char, idx2) => (
                        <div
                          key={idx2}
                          style={{
                            position: "relative",
                            display: "inline-block",
                            transform: "translate(0px, 0px)",
                            opacity: 1,
                          }}
                        >
                          {char}
                        </div>
                      ))}
                      &nbsp;
                    </span>
                  ))}
                </div>
              </h2>
            </div>
            <p className="back-btn">
              <a href="/">Home</a> / Course
            </p>
          </div>
          <a href="tel:+917619617023" className="phone-number">
            (+91) 7619617023
          </a>
        </div>
      </section>
      
      <div class="course-container">
        <div class="header">
          <h1 class="title">Semiconductor Packaging Courses</h1>
          <div class="program-info">
            <h2 class="info-title">Program Information</h2>
            <ul class="program-info-list">
              <li class="program-info-item">
                Short Term Programmes (0.5 day to 1 day)
              </li>
              <li class="program-info-item">
                Industry Case Studies and Videos included to enhance
                participants comprehension
              </li>
              <li class="program-info-item">
                Can be offered onsite if required
              </li>
            </ul>
          </div>
        </div>
        <div class="courses-grid">
          <div class="course-card">
            <h3 class="course-title">
              Wafer Backgrinding - Process, Equipment, Metrology
            </h3>
            <p class="course-description">
              Techniques and equipment for wafer thickness reduction and surface
              preparation
            </p>
            <span class="category-tag">Wafer Processing</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">
              Wafer Dicing - Process, Equipment, Metrology
            </h3>
            <p class="course-description">
              Methods and tools for separating wafers into individual die
            </p>
            <span class="category-tag">Wafer Processing</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">
              Die Attach, Flip Chip - Process, Equipment, Metrology
            </h3>
            <p class="course-description">
              Processes for mounting semiconductor die to substrates
            </p>
            <span class="category-tag">Module Engineering</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">
              Wire Attach - Process, Equipment, Metrology
            </h3>
            <p class="course-description">
              Wire bonding techniques and equipment for chip connections
            </p>
            <span class="category-tag">Module Engineering</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">
              Molding, Encapsulation - Process, Equipment, Metrology
            </h3>
            <p class="course-description">
              Methods for protecting and sealing semiconductor packages
            </p>
            <span class="category-tag">Module Engineering</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">Flip Chip Attach</h3>
            <p class="course-description">
              Advanced techniques for flip chip mounting and connections
            </p>
            <span class="category-tag">Advanced Assembly</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">Reliability of Wire Bonded Packages</h3>
            <p class="course-description">
              Testing and reliability assessment of wire bonded packages
            </p>
            <span class="category-tag">Reliability</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">Reliability of Flip Chip Packages</h3>
            <p class="course-description">
              Testing and reliability assessment of flip chip packages
            </p>
            <span class="category-tag">Reliability</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">3D Packaging, TSV </h3>
            <p class="course-description">
              Through-silicon via and 3D integration technologies
            </p>
            <span class="category-tag">Advanced Technology</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Packaging;
